/*!
 * unset-value <https://github.com/jonschlinkert/unset-value>
 *
 * Copyright (c) 2015, 2017, Jon Schlinkert.
 * Released under the MIT License.
 */

'use strict';

const isObject = require('isobject');
const has = require('has-value');

module.exports = function unset(obj, prop) {
    if (!isObject(obj) && !Array.isArray(obj)) {
        throw new TypeError('expected an object.');
    }
    if (isObject(obj) && obj.hasOwnProperty(prop)) {
        delete obj[prop];
        return true;
    }
    if (Array.isArray(obj) && !isNaN(prop) && obj[prop]) {
        obj.splice(props, 1);
        return true;
    }

    if (has(obj, prop)) {
        let segs = prop.split('.');
        let last = segs.pop();
        while (segs.length && segs[segs.length - 1].slice(-1) === '\\') {
            last = segs.pop().slice(0, -1) + '.' + last;
        }
        while (segs.length) obj = obj[prop = segs.shift()];
        return (delete obj[last]);
    }
    return true;
};